module.exports = __webpack_public_path__ + "img/number01.688924d3.svg";